import { get, isNil, noop, pick, pickBy } from 'lodash';
import { SPAN_SCOPE_METRICS_ATTRIBUTES } from '../config/spanScopeMetricAttributes';
import { METRIC_TRACE_SCOPE_SATUS_MAP } from './metricTraceScopeStatusMap';

export const getTraceMetricAttributes = span => {
    const allowedKeys = get(SPAN_SCOPE_METRICS_ATTRIBUTES, span.name, []);
    const traceScopeStatusGetter = METRIC_TRACE_SCOPE_SATUS_MAP[span.name] || noop;

    const spanAttributes = {
        traceScope: span.name,
        status: traceScopeStatusGetter(span),
        ...pick(span.attributes, allowedKeys),
    };
    const metericAttributes = pickBy(spanAttributes, value => !isNil(value));
    return metericAttributes;
};
